document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-number-builder]').forEach(function (builder) {

    const sectionId = builder.id.replace('NumberBuilder-', '');

    const jsonElement = document.querySelector(
      '#NumberProducts-' + sectionId
    );

    if (!jsonElement) {
      console.error('Number Builder: product JSON not found.');
      return;
    }

    let numberProducts;

    try {
      numberProducts = JSON.parse(jsonElement.textContent);
    } catch (error) {
      console.error('Number Builder: invalid JSON.', error);
      return;
    }

    console.log('Number Builder Products:', numberProducts);

    const config = {
      color: 'black',
      mode: 'single',
      first: null,
      second: null
    };

    const colorButtons = builder.querySelectorAll('.color-btn');
    const modeButtons = builder.querySelectorAll('.mode-btn');
    const firstButtons = builder.querySelectorAll('.first-digit');
    const secondButtons = builder.querySelectorAll('.second-digit');

    const secondWrapper = builder.querySelector('.second-wrapper');

    const addButton = builder.querySelector('[data-number-add]');
    const addButtonText = builder.querySelector('[data-number-add-text]');
    const errorElement = builder.querySelector('[data-number-error]');

    const priceElement = builder.querySelector('[data-number-price]');
    const priceValueElement = builder.querySelector('[data-number-price-value]');


    function clearError() {
      errorElement.textContent = '';
      errorElement.style.display = 'none';
    }


    function showError(message) {
      console.error('Number Builder:', message);

      errorElement.textContent = message;
      errorElement.style.display = 'block';
    }


    function updateButtonState() {
      let ready = false;

      if (config.mode === 'single' && config.first !== null) {
        ready = true;
      }

      if (
        config.mode === 'double' &&
        config.first !== null &&
        config.second !== null
      ) {
        ready = true;
      }

      addButton.disabled = !ready;

      updatePrice();
    }

    function updatePrice() {
      let totalPrice = 0;

      try {
        if (config.first === null) {
          priceElement.style.display = 'none';
          return;
        }

        const firstVariant = getVariant(config.first, config.color);

        totalPrice += Number(firstVariant.price);

        if (config.mode === 'double') {
          if (config.second === null) {
            priceElement.style.display = 'none';
            return;
          }

          const secondVariant = getVariant(config.second, config.color);

          totalPrice += Number(secondVariant.price);
        }

        priceValueElement.textContent = theme.Currency.formatMoney(
          totalPrice,
          theme.settings.moneyFormat
        );

        priceElement.style.display = 'block';

      } catch (error) {
        priceElement.style.display = 'none';
      }
    }


    /*
    COLOR
    */

    colorButtons.forEach(function (button) {

      button.addEventListener('click', function () {

        clearError();

        colorButtons.forEach(function (item) {
          item.classList.remove('active');
        });

        button.classList.add('active');

        config.color = button.dataset.color;

        updateButtonState();
      });

    });


    /*
    MODE
    */

    modeButtons.forEach(function (button) {

      button.addEventListener('click', function () {

        clearError();

        modeButtons.forEach(function (item) {
          item.classList.remove('active');
        });

        button.classList.add('active');

        config.mode = button.dataset.mode;

        if (config.mode === 'double') {
          secondWrapper.style.display = 'block';
        } else {
          secondWrapper.style.display = 'none';

          config.second = null;

          secondButtons.forEach(function (item) {
            item.classList.remove('selected');
          });
        }

        updateButtonState();
      });

    });


    /*
    FIRST DIGIT
    */

    firstButtons.forEach(function (button) {

      button.addEventListener('click', function () {

        clearError();

        firstButtons.forEach(function (item) {
          item.classList.remove('selected');
        });

        button.classList.add('selected');

        config.first = button.dataset.number;

        updateButtonState();
      });

    });


    /*
    SECOND DIGIT
    */

    secondButtons.forEach(function (button) {

      button.addEventListener('click', function () {

        clearError();

        secondButtons.forEach(function (item) {
          item.classList.remove('selected');
        });

        button.classList.add('selected');

        config.second = button.dataset.number;

        updateButtonState();
      });

    });


    /*
    GET VARIANT
    */

    function getVariant(number, color) {

      const product = numberProducts[String(number)];

      if (!product) {
        throw new Error(
          `Product for number ${number} was not found.`
        );
      }

      const variant = product[color];

      if (!variant) {
        throw new Error(
          `${color} variant for number ${number} was not found.`
        );
      }

      if (!variant.available) {
        throw new Error(
          `Number ${number} in ${color} is sold out.`
        );
      }

      return variant;
    }


    /*
    ADD TO CART
    */

    addButton.addEventListener('click', async function (event) {

      event.preventDefault();

      clearError();

      if (addButton.disabled) {
        return;
      }

      try {

        addButton.disabled = true;
        addButtonText.textContent = 'Adding...';

        const firstVariant = getVariant(
          config.first,
          config.color
        );

        const items = [
          {
            id: Number(firstVariant.id),
            quantity: 1
          }
        ];


        if (config.mode === 'double') {

          const secondVariant = getVariant(
            config.second,
            config.color
          );


          /*
          If user selects same number twice,
          e.g. 55
          */

          if (
            Number(firstVariant.id) ===
            Number(secondVariant.id)
          ) {

            items[0].quantity = 2;

          } else {

            items.push({
              id: Number(secondVariant.id),
              quantity: 1
            });

          }
        }


        console.log('Config:', config);
        console.log('Items to add:', items);


        const root =
          window.Shopify &&
          window.Shopify.routes &&
          window.Shopify.routes.root
            ? window.Shopify.routes.root
            : '/';


        const response = await fetch(
          root + 'cart/add.js',
          {
            method: 'POST',

            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },

            body: JSON.stringify({
              items: items
            })
          }
        );


        const data = await response.json();

        console.log('Shopify cart response:', data);


        if (!response.ok) {

          throw new Error(
            data.description ||
            data.message ||
            'Unable to add products to cart.'
          );

        }

        addButton.disabled = false;
        addButtonText.textContent = 'Add Number to Cart';


        /*
        For now:
        redirect to cart after success.

        Once confirmed working,
        we can integrate Impulse cart drawer.
        */

        document.dispatchEvent(
          new CustomEvent('ajaxProduct:added', {
            detail: {
              product: data
            }
          })
        );

        document.dispatchEvent(
          new CustomEvent('cart:build')
        );

        updateCartBubble();

        document.documentElement.dispatchEvent(
          new CustomEvent('cart:open')
        );


      } catch (error) {

        console.error(
          'Number Builder Add To Cart Error:',
          error
        );

        showError(
          error.message ||
          'Unable to add products to cart.'
        );

        addButton.disabled = false;
        addButtonText.textContent = 'Add Number to Cart';
      }

    });

  });
});

window.updateCartBubble = function () {
  return fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      document.querySelectorAll('.cart-link__bubble')
        .forEach(function (bubble) {

          bubble.textContent = cart.item_count;

          if (cart.item_count > 0) {
            bubble.classList.add(
              'cart-link__bubble--visible'
            );
          } else {
            bubble.classList.remove(
              'cart-link__bubble--visible'
            );
          }
        });
      return cart;
    })
    .catch(function(error){
      console.error(
        'Cart bubble update error:',
        error
      );
    });
};